import React, { useState } from "react";
import {
  Button,
  Flex,
  Text,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Center,
  Input,
  useToast
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import { WarningTwoIcon } from "@chakra-ui/icons";
import axios from "axios";
import { URL_WEB_BACKEND, decryptData } from "CustomUtil";

export default function ResetSukels(props) {
  const { onRefresh } = props;
  const authdata = decryptData(localStorage.getItem("authinfosemakinpas"));
  const cekadmin = decryptData(localStorage.getItem("authrolesemakinpas"));

  const [statusConfExeDialog, setStatusConfExeDialog] = useState(false);
  const [statusConfirmLayer2, setStatusConfirmLayer2] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [isExecuting, setIsExecuting] = useState(false);

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const toast = useToast();

  if (cekadmin !== "admin" && cekadmin !== "um") {
    return null;
  }

  const showDialogLayer1 = () => {
    setStatusConfExeDialog(true);
    setStatusConfirmLayer2(false);
    setConfirmText("");
  };

  const handleNextLayer = () => {
    setStatusConfExeDialog(false);
    setStatusConfirmLayer2(true);
  };

  const exeReset = async () => {
    setIsExecuting(true);
    await axios.post(URL_WEB_BACKEND + '/reset-all-nosukel-totals', {}, {
      headers: {
        'Authorization': 'Bearer ' + authdata
      }
    }).then((response) => {
      setIsExecuting(false);
      setStatusConfirmLayer2(false);
      if (response.status === 200) {
        toast({
          status: 'success',
          title: 'Reset Berhasil',
          description: response.data.messages.success,
          position: 'bottom-right',
          isClosable: true,
        });
        onRefresh();
      }
    }).catch((err) => {
      setIsExecuting(false);
      toast({
        status: 'error',
        title: 'Reset Gagal',
        description: err.response?.data?.messages?.error || "Terjadi kesalahan sistem",
        position: 'bottom-right',
        isClosable: true,
      });
    });
  };

  const viewLayer1Dialog = () => {
    return (
      <Modal closeOnOverlayClick={true} isCentered isOpen={statusConfExeDialog} onClose={() => setStatusConfExeDialog(false)}>
        <ModalOverlay bg='blackAlpha.300' backdropFilter='blur(10px) hue-rotate(10deg)' />
        <ModalContent>
          <ModalHeader>Reset Global Penomoran</ModalHeader>
          <ModalBody>
            <Center><WarningTwoIcon w={16} h={16} color="red.500" /></Center>
            <Center mt={8}>
              <Text fontSize='large' textAlign="center">
                Apakah Anda yakin ingin mereset seluruh nomor urut surat keluar? Aksi ini akan membuat semua penomoran kembali ke 0.
              </Text>
            </Center>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='red' mr={3} onClick={handleNextLayer}>
              Iya, Lanjut
            </Button>
            <Button onClick={() => setStatusConfExeDialog(false)}>Batal</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };

  const viewLayer2Dialog = () => {
    return (
      <Modal closeOnOverlayClick={false} isCentered isOpen={statusConfirmLayer2} onClose={() => setStatusConfirmLayer2(false)}>
        <ModalOverlay bg='blackAlpha.300' backdropFilter='blur(10px) hue-rotate(10deg)' />
        <ModalContent>
          <ModalHeader>Konfirmasi Keamanan</ModalHeader>
          <ModalBody>
            <Text fontSize='md' mb={4}>
              Tindakan ini sangat berisiko, JANGAN LUPA BACKUP SEMUA DATA SURAT KELUAR TERLEBIH DAHULU. Silakan ketik kalimat berikut untuk memvalidasi niat Anda:
              <br /><br />
              <b>SAYA SETUJU RESET SEMUA</b>
            </Text>
            <Input
              placeholder="Ketik persetujuan di sini..."
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme='red'
              mr={3}
              isLoading={isExecuting}
              isDisabled={confirmText !== "SAYA SETUJU RESET SEMUA"}
              onClick={exeReset}
            >
              Eksekusi Reset
            </Button>
            <Button onClick={() => setStatusConfirmLayer2(false)}>Batal</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };

  return (
    <Card p='20px' align='center' direction='column' w='100%' bg="red.50" mb="20px">
      <Flex justifyContent='space-between' alignItems='center' w='100%'>
        <Flex direction="column">
          <Text color="red.700" fontSize='lg' fontWeight='700'>
            Zona Berbahaya: Reset Nomor Surat Keluar
          </Text>
          <Text color="red.600" fontSize='sm' mt='4px'>
            Gunakan fitur ini hanya pada saat awal tahun untuk mengembalikan seluruh counter nomor urut kembali ke 0.
          </Text>
        </Flex>
        <Button colorScheme="red" onClick={showDialogLayer1}>
          RESET SEMUA PENOMORAN
        </Button>
      </Flex>
      {viewLayer1Dialog()}
      {viewLayer2Dialog()}
    </Card>
  );
}
